import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["label", "value", "name", "id", "placeholder", "disabled", "rows"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Textarea = /*#__PURE__*/forwardRef(function Input(props, ref) {
  var label = props.label,
      value = props.value,
      name = props.name,
      id = props.id,
      placeholder = props.placeholder,
      disabled = props.disabled,
      rows = props.rows,
      passThroughProps = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_jsx("div", {
    className: passThroughProps.className,
    children: /*#__PURE__*/_jsxs("div", {
      className: "relative flex rounded-md border border-gray-300 bg-white px-1 text-sm ".concat(label ? 'pt-4' : '', " ").concat(disabled ? 'opacity-50' : ''),
      children: [/*#__PURE__*/_jsx("textarea", _objectSpread(_objectSpread({}, passThroughProps), {}, {
        ref: ref,
        className: "peer w-full border-0 font-medium text-gray-900 focus:outline-none focus:ring-0 ".concat(label ? 'placeholder-transparent' : '', " ").concat(disabled ? 'pointer-events-none cursor-not-allowed' : 'cursor-auto'),
        style: {
          height: "".concat(rows, "rem")
        },
        id: id,
        name: name,
        value: value,
        rows: rows,
        disabled: disabled,
        placeholder: label || placeholder
      })), label && /*#__PURE__*/_jsx("label", {
        htmlFor: name,
        className: "origin-0 -z-1 pointer-events-none absolute top-2 left-4 block text-xs text-gray-600 transition-all peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-focus:top-2 peer-focus:text-xs peer-focus:text-gray-600",
        children: label
      })]
    })
  });
});
export default Textarea;